'use client';
import { jsx } from 'react/jsx-runtime';
import { removePrefix } from '../utilities.js';

const ComboboxNative = ({ selectedOptions, multiple, name, }) => {
    const VALUE = Object.keys(selectedOptions).map((key) => removePrefix(key));
    return (jsx("select", { name: name, multiple: multiple, style: { display: 'none' }, value: multiple ? VALUE : VALUE[0], onChange: () => { }, children: VALUE.map((value) => (jsx("option", { value: value }, value))) }));
};
ComboboxNative.displayName = 'ComboboxNative';

export { ComboboxNative as default };
